<template>
	<label
		:class="cn(
			'block text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
			props.class
		)"
		v-bind="$attrs"
	>
		<slot />
	</label>
</template>

<script setup lang="ts">
import { cn } from '../../../utils/cn';

const props = defineProps<{
	class?: string;
}>();
</script>
